const ERROR_TRANSLATIONS: Record<string, string> = {
  userResponsibleType: "O tipo de acesso selecionado não é permitido para este colaborador.",
};

function translateErrorMessage(message?: string): string | undefined {
  if (!message) return undefined;
  const matched = Object.entries(ERROR_TRANSLATIONS).find(([key]) =>
    message.toLowerCase().includes(key.toLowerCase())
  );
  return matched ? matched[1] : message;
}

interface AccessCreationErrorModalProps {
  handleModal: (modalState: { isOpen: boolean }) => void;
  errorMessage?: string;
}

function AccessCreationErrorModal({ handleModal, errorMessage }: AccessCreationErrorModalProps) {
  const translatedMessage = translateErrorMessage(errorMessage);

  return (
    <>
      <p>
        Não foi possível criar o acesso de gerente.
      </p>
      {translatedMessage && (
        <p className="mt-2 text-sm text-red-600 bg-red-50 p-3 rounded-md">
          <strong>Motivo:</strong> {translatedMessage}
        </p>
      )}
      <p className="mt-2 text-sm text-gray-500">
        Verifique se o cargo do colaborador já foi atualizado no Logix
        e tente novamente.
      </p>
      <button
        className="mt-6 self-end w-max px-4 py-2 border border-black/20 flex items-center gap-2 rounded-md text-black bg-white transition-all duration-300 ease-in-out hover:bg-[#2B0C1A] hover:text-white hover:border-transparent"
        onClick={() => handleModal({ isOpen: false })}
      >
        Entendi
      </button>
    </>
  );
}

export default AccessCreationErrorModal;
